import TPoptip from './reference.vue'

TPoptip.install = Vue => {
  Vue.component(TPoptip.name, TPoptip)
}

export {
  TPoptip
}



// WEBPACK FOOTER //
// ./src/module/poptip/index.js